import { render, staticRenderFns } from "./ProductSidebar.vue?vue&type=template&id=5d1d3b36&scoped=true"
import script from "./ProductSidebar.vue?vue&type=script&lang=js"
export * from "./ProductSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductSidebar.vue?vue&type=style&index=0&id=5d1d3b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d3b36",
  null
  
)

export default component.exports